import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';

// for ESM or TypeScript
// import { Config } from '@mifiel/api-client-auth';
// const { Config } = require('@mifiel/api-client-auth');

// Config.setTokens({
//   appId: '<APP_ID>',
//   appSecret: '<APP_SECRET>',
  // [optional] - by default is production
  // env: 'production' | 'sandbox' 
//   env: 'sandbox'
// });

@Injectable({
  providedIn: 'root'
})
export class MifielSignatureService {
  // private baseUrl = 'http://localhost:8080';
  private baseUrl = environment.url3;
  private activeUser: boolean;
  private mifielEnabled: boolean;
  private maxMonthSignatures: number;
  private userTaxId: string;
  private power: boolean;

  constructor(private http: HttpClient) { }

  setMiFielSignature(activeUser: boolean,  mifielEnabled: boolean,
    maxMonthSignatures: number, power: boolean
  ){
    this.activeUser = activeUser;
    this.mifielEnabled = mifielEnabled;
    this.maxMonthSignatures = maxMonthSignatures;
    this.power = power;
    console.log('mifiel-signature.service.ts -> setMiFielSignature');
    console.log(this.power)
  }

  getActiveUser(){ return this.activeUser; }

  getMifielEnabled(){ return this.mifielEnabled;}

  getMaxMonthSignatures(){ return this.maxMonthSignatures; }

  getPowersEnabled(){ return this.power; }

  upload(file: File, data: any ): Observable<HttpEvent<any>> {
    const headers = new HttpHeaders()
    // .append( 'Content-Type', 'application/json; charset=UTF-8')
    .append('Autorizzazione', localStorage.getItem('token')); // Add the 'Autorizzazione' header

    const formData: FormData = new FormData();

    formData.append('file', file);
    // formData.append('Signatories',JSON.stringify(data.signatories));
    formData.append('Signatories',data.signatories);
    formData.append('Days_to_expire',data.days_to_expire);
    formData.append('Message_for_signers',data.message_for_signers);
    formData.append('Remind_every','1');
    formData.append('Send_invites',data.send_invites);
    // formData.append('Viewers',JSON.stringify(data.viewers));
    formData.append('Viewers',data.viewers);
    formData.append('TargetTaxId', data.TargetTaxId);
    formData.append('UserTaxId',localStorage.getItem('userTaxId'));
    console.log(formData);
    console.log(data);

    const req = new HttpRequest('POST', `${this.baseUrl}/mifiel/upload`, formData, {
      reportProgress: true,
      responseType: 'json',
      headers: headers
    });

    return this.http.request(req);
  }

  // getFiles(): Observable<any> {
  //   return this.http.get(`${this.baseUrl}/file/files`);
  // }
  // getFiles(): Observable<any> {
  //   let headers = new HttpHeaders()
  //   .append('Content-Type', 'application/json')
  //   .append('Autorizzazione', localStorage.getItem('token'));
  //   return this.http.get(`${this.baseUrl}/file/files`,{ headers }).pipe( map( data => data));
  // }

  getCountByUserTaxId(userTaxId: string): Observable<any> {
    let headers = new HttpHeaders()
    .append('Autorizzazione', localStorage.getItem('token'));
    return this.http.get(`${this.baseUrl}/mifiel/count?userTaxId=${userTaxId}`,{ headers }).pipe( map( data => data));
  }

  getDocumentsByUserTaxId(userTaxId: string): Observable<any> {
    let headers = new HttpHeaders()
    .append('Autorizzazione', localStorage.getItem('token'));
    return this.http.get(`${this.baseUrl}/mifiel/mifiel_files?userTaxId=${userTaxId}`,{ headers }).pipe( map( data => data));
  }

  previewDocument(idRef: string): Observable<any>{
    // const headers = new HttpHeaders()
    // .append( 'Content-Type', 'application/json; charset=UTF-8')
    // .append('Autorizzazione', localStorage.getItem('token')); // Add the 'Autorizzazione' header

    // const formData: FormData = new FormData();
    // formData.append('userTaxId', localStorage.getItem('userTaxId'));
    // formData.append('idRef', idRef)


    // const req = new HttpRequest('POST', `${this.baseUrl}/mifiel/preview`, formData, {
    //   reportProgress: true,
    //   responseType: 'json',
    //   headers: headers
    // });
    // return this.http.request(req);
    this.userTaxId =localStorage.getItem('userTaxId');
    let headers = new HttpHeaders()
      .append('Autorizzazione', localStorage.getItem('token'));
    return this.http.get(`${this.baseUrl}/mifiel/preview?userTaxId=${this.userTaxId}&idRef=${idRef}`,{ headers,responseType: 'blob' }).pipe( map( data => data));

  }

  // // miFielSignatureService.ts
  // previewDocument(idRef: string): Observable<Blob> {
  //   return this.http.get(`${this.baseUrl}/preview?userTaxId=Tracer&idRef=${idRef}`, {
  //     responseType: 'blob' // Specify that the response type is a blob
  //   });
  // }


}
